import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Requires authentication. If logged out, opens the login modal and
// bounces to home (the modal overlays home so the user can sign in).
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, openLogin } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) openLogin();
  }, [isAuthenticated, openLogin]);

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }
  return children;
};
